import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface GetAccountManagerApiParameter extends ApiParameter {
    custommerId: string[];
}

const getAccountManagerUrl = "/api/v1/salesrepresentative";

export function getAccountManager(parameter: GetAccountManagerApiParameter) {
    return get<any>(`${getAccountManagerUrl}/customerid/${parameter}`);
}
